import Grid from '@mui/material/Grid';
import colors from '/@/components/theme-provider/colors';
import acceleronLogo from '/@/v3/styles/assets/logos/acceleron.svg';

const AcceleronDivider = () => {
    return (
        <Grid container justifyContent='center' alignItems='center' sx={{ backgroundColor: colors.gray[700], my: 1 }}>
            <Grid container item xs={10} md={8} lg={6} justifyContent='center' alignItems='center' sx={{ my: 2 }}>
                <Grid item xs={12} sm={6}>
                    <img src={acceleronLogo} alt='acceleron' />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AcceleronDivider;
